import { createApp, type App } from 'vue';
import ClueReportDialog from './src/components/ClueReportDialog.vue';
import { i18n } from './src/i18n';
import { loadScript } from '@eureka/utils/load-script';
import { HUBSPOT_IFRAME_URL, getTargetEditionFormConfig } from './src/constants';
import type { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import type { EActivityTriggerType } from '@eureka/services/src/types/activity-type';

/**
 * @description 打开线索报告弹窗
 * @param {EUserPackage} edition - Required 打开线索弹窗的场景必须传目标版本
 * @param {EActivityTriggerType} sourceType - Optional 执行时的场景作为来源
 * @returns {Promise<boolean | undefined>} - 返回一个 Promise 对象，表示操作的完成情况
 */
export const openClueReport = (edition: EurekaPackageType, sourceType?: EActivityTriggerType) => {
    const targetEditionFormConfig = getTargetEditionFormConfig(edition);
    const version = edition.split('_')[0];
    if (!targetEditionFormConfig) {
        throw new Error(`[openClueReport] edition ${edition} is not mapping write in getTargetEditionFormConfig`);
    }
    const option = {
        ...targetEditionFormConfig,
        sourceType,
        version,
    }
    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    document.body.appendChild(div);

    const unmountApp = (app: App) => {
        app.unmount();
        document.body.removeChild(div);
    };

    const promise = new Promise<boolean | undefined>((resolve) => {
        const app = createApp(ClueReportDialog, {
            ...option,
            callback: () => {
                resolve(true);
                unmountApp(app);
            },
            onClose: () => {
                resolve(true);
                unmountApp(app);
                option?.onClose?.();
            },
        });
        app.use(i18n);
        app.mount(div);
        // @ts-ignore
        if (!window.hbspt) {
            loadScript(HUBSPOT_IFRAME_URL);
        }
    });

    return promise;
}
